import React from 'react';

type PropsType = {
    header?: boolean;
};

/**
 * Represents a "404" error message
 */
export function Page404({ header = true }: PropsType) {
    return (
        <div>
            {header && <div className="w3-container w3-row w3-white header">
                <div className="w3-container w3-cell w3-quarter w3-padding-16 w3-mobile w3-hide-small">
                    <img className="w3-image w3-left ADT_img" src="/icons/adt-logo.png" alt="ADT logo" width="100" />
                </div>
                <div className="w3-cell w3-half w3-mobile w3-center">
                    <div className="w3-large w3-wide w3-opacity"
                        style={{ color: '#0059b3', margin: '8px', textShadow: '1px 1px 0 #444' }}>
                        <b>Service Hub</b>
                    </div>
                </div>
            </div>}
            <div className="w3-center w3-padding-32">
                <h5>&#10060;&nbsp; Unfortunately, the requested page does not exist (yet). &nbsp;</h5>
                <br /><br />
                &#9664; <a href="#">Return to the real world</a>
            </div>
        </div>
    );
}
